export enum ECallState {
  'INITIATED' = 'INITIATED',
  'TRYING' = 'TRYING',
  'RINGING' = 'RINGING',
  'ANSWERED' = 'ANSWERED',
  'ACTIVE' = 'ACTIVE',
  'ONHOLD' = 'ONHOLD',
  'ENDED' = 'ENDED',
  'ERROR' = 'ERROR',
  'CANCEL' = 'CANCEL',
  'NONE' = 'NONE',
}
